//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Badge from '../../../../shared-components/badge/Badge';
import UsuarioToolbar from './UsuarioToolbar';
import resourceTermoAceite from '../../../../common/resources/termo-aceite';
import CalendarioToolbar from '../../../../spa/calendario/CalendarioToolbar';

export default {
  props: {
    hideMenu: {
      type: Boolean,
      default() { return false; },
    },
    title: {
      type: String,
      default() { return ''; },
    },
    options: {
      type: Array,
      default() { return []; },
    },
    usuario: String,
    mail: String,
    estruturaUsuario: String,
    perfil: String,
  },
  data() {
    return {
      termoAceiteResources: resourceTermoAceite(this.$resource),

      progress: 0,
      progressInterval: null,
      done: false,
      transition: true,
      termos: [],
    };
  },
  components: {
    Badge,
    UsuarioToolbar,
    CalendarioToolbar,
  },
  methods: {
    logout() {
      const auth = this.$auth || window.auth;
      auth.logout();
    },
    toggleSidenav() {
      this.$emit('TOGGLE_SIDEBAR');
    },
    irInicio() {
      if (this.$router.currentRoute.name !== 'dashboard') {
        this.$router.push({ name: 'inicio' });
        this.$emit('Toolbar_rotaAlterada');
      }
    },
    goToAceitePage() {
      this.$router.push({ name: 'termoAceiteRealizado' });
    },
    buscarAceites() {
      const params = {
        numeroPagina: 1,
        tamanhoPagina: 10,
        filter: '',
      };

      this.termoAceiteResources.listarRealizados(params)
        .then((response) => {
          this.termos = response.data.resposta;
        });
    },
  },
  mounted() {
    this.buscarAceites();
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/shared-components/toolbar/Toolbar.vue?vue&type=script&lang=js&